import script from "./AdminRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRegister.vue?vue&type=script&setup=true&lang=js"

import "./AdminRegister.vue?vue&type=style&index=0&id=46ed82e9&lang=scss"

const __exports__ = script;

export default __exports__